import script from "./Modal.vue?vue&type=script&setup=true&lang=js"
export * from "./Modal.vue?vue&type=script&setup=true&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=6e205aca&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\osago\\landing-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e205aca"]])

export default __exports__